import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PayService {

  private id_transaction: any
  private montant_base: any
  private montant: any
  private remise: any
  private commission_supplementaire: any
  private montantinter: any
  private date_paiement: any
  private nom_boutique: any
  private code_paiement: any
  private mode_paiement: any
  private referencePaiement: any
  private dateCommande: any

  constructor() { }

  setPay() {
    if (!localStorage.getItem('Pay')){
      localStorage.setItem('Pay','0');
    }
  }

  DeletePay() {
    localStorage.removeItem('Pay');
  }

  getPay(){
    return localStorage.getItem('Pay')
  }

  

  setTransactionInfo(
    id_transaction :any,
    montant_base :any,
    montant:any,
    remise :any,
    commission_supplementaire :any,
    montantinter :any,
    date_paiement :any,
    nom_boutique :any,
    code_paiement :any,
    mode_paiement :any,
    referencePaiement :any,
    dateCommande :any,
    ) 
    {
      this.id_transaction = id_transaction;
      this.montant_base = montant_base;
      this.montant = montant;
      this.remise = remise;
      this.commission_supplementaire =commission_supplementaire;
      this.montantinter = montantinter;
      this.date_paiement = date_paiement;
      this.nom_boutique = nom_boutique;
      this.code_paiement =code_paiement;
      this.mode_paiement = mode_paiement;
      this.referencePaiement = referencePaiement;
      this.dateCommande = dateCommande;
    }


  getIdTransaction():any {
    return this.id_transaction;
  }
  getMontantBase():any {
    return this.montant_base;
  }
  getMontant():any {
    return this.montant;
  }
  getRemise():any {
    return this.remise;
  }
  getCommissionSupplementaire():any {
    return this.commission_supplementaire;
  }
  getMontantinter():any {
    return this.montantinter;
  }
  getDatePaiement():any {
    return this.date_paiement;
  }
  getNomBoutique():any {
    return this.nom_boutique;
  }
  getCodePaiement():any {
    return this.code_paiement;
  }
  getModePaiement():any {
    return this.mode_paiement;
  }

  getReferencePaiement():any {
    return this.referencePaiement;
  }
  getdateCommande():any {
    return this.dateCommande;
  }
}